import axios from "axios";

export default function Api() {
  let instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_API_URL,
    timeout: 5000,
    withCredentials: true,
  });
  // instance.interceptors.request.use(config => {
  //     return config;
  // });
  // instance.interceptors.response.use(undefined, error => {
  //     console.log(error);
  //     if(error.response.status === 401) {
  //         return (<AlertComponent errorMessage="please login"/>)
  //     }
  //     else {
  //         return Promise.reject(error);
  //     }
  // });
  return instance;
}
